import { Trans } from '@lingui/react/macro';

import { InputMoney } from '@/design_system/InputNumber';

import { useArticleContext } from '../../contexts/ArticleContext';

export const RetailPrice = () => {
  const { article } = useArticleContext();

  if (article.product?.data?.purchaseValue === undefined) {
    return null;
  }

  return (
    <InputMoney
      label={<Trans id="article.form.retail-price.label">Retail price</Trans>}
      value={article.product.data.purchaseValue.amount}
      currency={article.product.data.purchaseValue.currency}
      isDisabled
    />
  );
};
